import { Button, ProgressLoader, Text, VSpacer } from '@/components/DesignSystem';
import { QueryKeys } from '@/constants/QueryKeys';
import { Routes } from '@/constants/Routes';
import { NotificationRecipientsContent }
  from '@/pages/Admin/NotificationBuilder/components/NotificationRecipientsContent';
import { ScheduledNotificationApi } from '@/utilities/api/ScheduledNotificationApi';
import DownloadIcon from '@mui/icons-material/GetApp';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Container, Stack } from '@mui/material';
import { FilterOptions } from '@shared/interfaces/ScheduledNotification';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useMatch, useNavigate, useParams } from 'react-router-dom';

export const ScheduledNotificationRecipientsPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const isAdminRoute = useMatch(Routes.ADMIN_SCHEDULED_NOTIFICATION);
  const notificationBuilderRoute = isAdminRoute
    ? Routes.ADMIN_NOTIFICATION_BUILDER
    : Routes.NOTIFICATION_BUILDER;
  const { t } = useTranslation();
  const [showExportConfirmationDialog, setShowExportConfirmationDialog] = useState(false);

  const { data: scheduledNotification, isLoading: isNotificationLoading } = useQuery(
    [QueryKeys.GET_SCHEDULED_NOTIFICATION, id],
    () => ScheduledNotificationApi.get(id!),
    { enabled: !!id },
  );

  const options = (scheduledNotification?.options || {}) as FilterOptions;
  const csvRecipientsData = scheduledNotification?.csvRecipientData || [];
  const retailerId = scheduledNotification?.retailerId || '';

  if (isNotificationLoading) {
    return (
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          height: '90vh',
          justifyContent: 'center',
          zIndex: 9999,
        }}
      >
        <ProgressLoader type="circular" />
      </div>
    );
  }

  return (
    <Container maxWidth="xl">
      <Stack alignItems="flex-start" marginLeft="-14px">
        <Button
          onClick={() => navigate(notificationBuilderRoute)}
          startIcon={<KeyboardBackspaceIcon />}
          testID="back-to-notification-builder-button"
          variant="text"
        >
          {t($ => $.notificationBuilder.modal.recipients.backToNotificationBuilder)}
        </Button>
      </Stack>
      <Stack direction="row" justifyContent="space-between">
        <Text category="title-large" testID="recipients-page-title">
          {t($ => $.notificationBuilder.modal.recipients.title)}
        </Text>
        <Button
          color="primary"
          disableElevation
          endIcon={<DownloadIcon fontSize="small" />}
          onClick={() => setShowExportConfirmationDialog(true)}
          testID="download-csv-button"
          variant="text"
        >
          {t($ => $.notificationBuilder.actions.downloadCsv)}
        </Button>
      </Stack>
      <VSpacer size="2" />
      <NotificationRecipientsContent
        csvRecipientData={csvRecipientsData}
        onExportDialogClose={() => setShowExportConfirmationDialog(false)}
        options={options}
        retailerId={retailerId}
        scheduledNotificationId={id}
        showExportDialog={showExportConfirmationDialog}
      />
    </Container>
  );
};
